export default __webpack_public_path__ + "static/media/bannerArrow.600aab27.svg";